import { Navigate, RouterProvider, createBrowserRouter } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { BannerProvider } from './components/ui/Banners';
import { AdminConfigProvider } from './features/config/AdminConfigProvider';
import { LoginPage } from './features/auth/LoginPage';
import { TransfersPage } from './features/transfers/TransfersPage';
import { ClientsPage } from './features/clients/ClientsPage';
import { AdminUsersPage } from './features/admins/AdminUsersPage';
import { NotFound } from './routes/NotFound';
import { RequireSession } from './routes/RequireSession';

/** The production bundle is served by the API at `/admin`. */
export const ROUTER_BASENAME = '/admin';

export const routes = [
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: (
      <RequireSession>
        {/* Runtime display settings (see the "Runtime configuration" section) are fetched once, after sign-in. */}
        <AdminConfigProvider>
          <AppLayout />
        </AdminConfigProvider>
      </RequireSession>
    ),
    children: [
      { index: true, element: <Navigate to="/transfers" replace /> },
      { path: 'transfers', element: <TransfersPage /> },
      { path: 'clients', element: <ClientsPage /> },
      { path: 'admin-users', element: <AdminUsersPage /> },
    ],
  },
  { path: '*', element: <NotFound /> },
];

const router = createBrowserRouter(routes, { basename: ROUTER_BASENAME });

export function App() {
  return (
    <BannerProvider>
      <RouterProvider router={router} />
    </BannerProvider>
  );
}
